import React from 'react';
import styles from './AutoCAD.module.css';

//mport { libraries, tnb } from './links';

const ArchitectCornerPage = () => {
  return (
    <section className={styles.architects_corner}>
      <h1 className={styles.architects_title}>AutoCAD Library</h1>

      <div className={styles.ac_grid}>
        {/* Trims */}
        <div>
          <h2 className={styles.ac_title}>Contact us.</h2>
          {/* <ul className={styles.library_list}>
            {libraries.map((library) => (
              <li key={library.id}>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={library.link}
                >
                  <b>{library.series}</b> {library.product}
                </a>
              </li>
            ))}
          </ul> */}
        </div>

        {/* TnB */}
        {/* <div>
          <h2 className={styles.ac_title}>Tables and benches</h2>
          <ul className={styles.library_list}>
            {tnb.map((tb) => (
              <li key={tb.id}>
                <a target="_blank" rel="noopener noreferrer" href={tb.link}>
                  <b>{tb.series}</b> {tb.product}
                </a>
              </li>
            ))}
          </ul>
        </div> */}
      </div>
    </section>
  );
};

export default ArchitectCornerPage;
